<template>
  <div class="main-contain">
    <div class="module-title">
      <div class="main-title-text title-box">机组水力性能趋势分析({{ timeMap[timeType] }})</div>
      <div class="handle-line">
        <div class="time-box">
        </div>
        <div class="box">
          <div class="legend-box">
            <div class="legend rate">机组效率</div>
            <div class="legend f">F值</div>
            <div class="legend water">耗水率</div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="line"
      @click="showDialog"
    >
      <div class="chart-box">
        <div class="chart_num">
          <span class="chart_name">1号机组</span>
        </div>
        <line-chart
          style="width: 88%"
          id="machineOne"
          title=""
          ref="lineChart1"
        ></line-chart>
      </div>
    </div>
    <div
      class="line"
      @click="showDialog"
    >
      <div class="chart-box">
        <div class="chart_num">
          <span class="chart_name">2号机组</span>
        </div>
        <line-chart
          style="width: 88%"
          id="machineTwo"
          title=""
          ref="lineChart2"
        ></line-chart>
      </div>
    </div>
    <div
      class="line"
      @click="showDialog"
    >
      <div class="chart-box">
        <div class="chart_num">
          <span class="chart_name">3号机组</span>
        </div>
        <line-chart
          style="width: 88%"
          id="machineThree"
          title=""
          ref="lineChart3"
        ></line-chart>
      </div>
    </div>
    <model-one-dialog
      title="机组水力性能趋势分析"
      ref="modelOneDialogRef"
      width="25%"
      @refresh="getDataByParams"
    />
  </div>
</template>

<script>
import { api } from '@/api/api'
import LineChart from './echartComponents/LineChart.vue'
import ModelOneDialog from './dialogComponents/ModelOneDialog.vue'

export default {
  components: {
    LineChart,
    ModelOneDialog
  },
  data() {
    return {
      chart: null,
      dateRange: [],
      timeType: 1,
      timeMap: {
        1: '日',
        2: '周',
        3: '月',
        4: '季',
        5: '年',
      },
      timer: null
    }
  },
  watch: {
  },
  mounted() {
    setTimeout(() => {
      this.setTimer()
    },2000)
  },
  beforeDestroy() {
    this.clearTimer()
  },
  methods: {
    getDataByParams(params) {
      this.timeType = params.unitTrendAnalysisTimeType
      this.$http.get({ url: api.unitTrendAnalysis }).then(res => {
        res.data.list.forEach(v => {
          if (!v) v = []
        })
        let dataList = res.data.list
        this.setData(dataList)
      })
    },
    setTimer() {
      this.timer = setInterval(() => {
        this.getDataByParams({unitTrendAnalysisTimeType: this.timeType})
      },60000)
    },
    clearTimer() {
      clearInterval(this.timer)
      this.timer = null
    },
    showDialog() {
      this.$refs.modelOneDialogRef.show('ModelOneDetail')
    },
    setData(dataList) {
      this.$refs.lineChart1.initChart([...dataList[0].list])
      this.$refs.lineChart2.initChart([...dataList[1].list])
      this.$refs.lineChart3.initChart([...dataList[2].list])
    },
    setTitle(setting) {
      this.timeType = setting.unitTrendAnalysisTimeType
    }
  }
}
</script>

<style scoped>
.time-box /deep/ .el-range-editor--mini .el-range-input {
  background: #0c2341 !important;
  color: #fff;
}
.time-box .date-picker {
  width: 230px !important;
  background-color: #0c2342 !important;
  border: 1px solid #1a4c89 !important;
}
</style>

<style scoped lang="scss">
.main-contain {
  height: 100%;
  width: 100%;
  padding: 0 15px;
  .module-title {
    padding-top: 20px;
    height: 9%;
    width: 100%;
    .title-box {
      display: flex;
      // &:before {
      //   content: url('@/assets/img/arrow.png');
      //   width: 25px;
      //   height: 25px;
      // }
    }
  }
  .line {
    display: flex;
    height: 28%;
    width: 100%;
    .chart-box {
      display: flex;
      align-items: center;
      height: 100%;
      width: 100%;
      .chart_num {
        color: #abd3ff;
        font-weight: bold;
        width: 10%;
        .chart_name {
          writing-mode: vertical-lr;
          text-orientation: upright;
          text-align: center;
          border: 1px solid #0a52a4;
          border-radius: 5px;
          padding: 18px 8px;
          background: #06112d;
          box-shadow: 0 -1px 3px 2px #073e7f;
          font-size: 18px;
        }
      }
    }
  }
  .handle-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 20px;
    .box {
      width: 100%;
      .legend-box {
        display: flex;
        justify-content: center;
        .legend {
          color: #fff;
          position: relative;
          font-size: 15px;
          &:nth-child(1) {
            margin-right: 30px;
          }
          &:nth-child(2) {
            margin-right: 30px;
          }
          &.rate:before {
            content: '';
            position: absolute;
            left: -20px; /* 将圆形置于文本左侧 */
            top: 50%;
            transform: translateY(-50%); /* 垂直居中对齐 */
            width: 12px; /* 圆形的宽度 */
            height: 12px; /* 圆形的高度 */
            background-color: #dcd32f; /* 圆形的背景颜色 */
            border-radius: 50%; /* 创建圆形 */
          }
          &.f:before {
            content: '';
            position: absolute;
            left: -20px; /* 将圆形置于文本左侧 */
            top: 50%;
            transform: translateY(-50%); /* 垂直居中对齐 */
            width: 12px; /* 圆形的宽度 */
            height: 12px; /* 圆形的高度 */
            background-color: #17c5fd; /* 圆形的背景颜色 */
            border-radius: 50%; /* 创建圆形 */
          }
          &.water:before {
            content: '';
            position: absolute;
            left: -20px; /* 将圆形置于文本左侧 */
            top: 50%;
            transform: translateY(-50%); /* 垂直居中对齐 */
            width: 12px; /* 圆形的宽度 */
            height: 12px; /* 圆形的高度 */
            background-color: #accfff; /* 圆形的背景颜色 */
            border-radius: 50%; /* 创建圆形 */
          }
        }
      }
    }
  }
}
</style>
